import React, { useState, useEffect } from "react";
import {
  ButtonRed,
  FormField,
  SelectBox,
  StatusMessage,
} from "../../style/view.styles";
import { fetchEntityData, saveEntityData } from "../../utils/RequestHandler";
import { getLoggedInProfile, getLoggedInUser } from "../../utils/AuthHandler";
import LoadingSpinner from "./LoadingSpinner";
// import AvatarIcon from "../../assets/svg/AvatarIcon";

const OrgProfileSection = () => {
  const [profile, setProfile] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formStatus, setFormStatus] = useState({ message: "", type: "" });
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [organizationTypes, setOrganizationTypes] = useState([]);
  const [industries, setIndustries] = useState([]);

  useEffect(() => {
    const fetchOrganizationTypes = async () => {
      try {
        const response = await fetchEntityData("organization_type");
        if (response.success) {
          setOrganizationTypes(response.result);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const fetchIndustries = async () => {
      try {
        const response = await fetchEntityData("industries");
        if (response.success) {
          setIndustries(response.result);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const fetchProfile = async () => {
      const defaultUser = { email: getLoggedInUser().username };
      try {
        const user = await getLoggedInProfile();
        setProfile(user ?? defaultUser);
        if (!user) {
          setIsEditing(true);
        }
      } catch (error) {
        console.error("Error fetching organization profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizationTypes();
    fetchIndustries();
    fetchProfile();
  }, []);

  const handleEditClick = (e) => {
    e.preventDefault();
    setIsEditing(true);
  };

  const handleSaveClick = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      setFormStatus({ message: "Saving profile ...", type: "error" });
      const user = getLoggedInUser();
      const requestData = {
        ...profile,
        added_by: user.username,
      };
      const response = await saveEntityData(
        "organizations",
        requestData,
        true,
        profile?.uuid
      );
      if (response.success) {
        setFormStatus({
          message: "Profile saved successfully!",
          type: "success",
        });
      } else {
        setFormStatus({
          message:
            response.message ?? "An error occurred while saving your profile.",
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsEditing(false);
      setSubmitting(false);
    }
  };

  return !loading && profile ? (
    <>
      {/* Avatar & User Info */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        {/* <div style={{ width: "100px", height: "100px", borderRadius: "50%", overflow: "hidden" }}>
          <AvatarIcon />
        </div> */}

        {/* Editable User Details */}
        <div style={{ flex: 1 }}>
          <FormField>
            <label>Organization Name</label>
            <input
              type="text"
              value={profile.name ?? ""}
              onChange={(e) => setProfile({ ...profile, name: e.target.value })}
              disabled={!isEditing}
            />
          </FormField>

          <FormField style={{ width: "98.7%" }}>
            <label>Type</label>
            <SelectBox
              value={profile.type ?? ""}
              onChange={(e) => setProfile({ ...profile, type: e.target.value })}
              disabled={!isEditing}
            >
              <option value="">
                {profile.type ? profile.type : "Select Type"}
              </option>
              {organizationTypes.map((option) => (
                <option key={option.type} value={option.id}>
                  {option.type}
                </option>
              ))}
            </SelectBox>
          </FormField>

          {/* Industry */}
          <FormField style={{ width: "98.7%" }}>
            <label>Industry</label>
            <SelectBox
              value={profile.industry ?? ""}
              onChange={(e) =>
                setProfile({ ...profile, industry: e.target.value })
              }
              disabled={!isEditing}
            >
              <option value="">
                {profile.industry ? profile.industry : "Select Industry"}
              </option>
              {industries.map((option) => (
                <option key={option.name} value={option.id}>
                  {option.name}
                </option>
              ))}
            </SelectBox>
          </FormField>
          {/* Bio Section */}
          <FormField>
            <label>About</label>
            <textarea
              value={profile.description ?? ""}
              onChange={(e) =>
                setProfile({ ...profile, description: e.target.value })
              }
              disabled={!isEditing}
              rows="4"
            />
          </FormField>

          <FormField>
            <label>Location</label>
            <input
              type="text"
              value={profile.location ?? ""}
              onChange={(e) =>
                setProfile({ ...profile, location: e.target.value })
              }
              disabled={!isEditing}
            />
          </FormField>
          {/* Edit / Save Button */}
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            {isEditing ? (
              <ButtonRed onClick={handleSaveClick} disabled={submitting}>
                Save
              </ButtonRed>
            ) : (
              <ButtonRed onClick={handleEditClick}>Edit</ButtonRed>
            )}
          </div>
          {formStatus.message && (
            <StatusMessage type={formStatus.type}>
              {formStatus.message}
            </StatusMessage>
          )}
        </div>
      </div>
    </>
  ) : (
    <LoadingSpinner />
  );
};

export default OrgProfileSection;
